import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useModal } from '@famly/mf_modals-dialogs_context';
import { Skeleton } from '@famly/mf_feedback_skeleton';
import { Box } from '@famly/mf_layout_box';
import { Stack } from '@famly/mf_layout_stack';
import {} from './kinder-connect-capture-settings-modal-form';
const loadKinderConnectCaptureSettingsModalForm = () => import('./kinder-connect-capture-settings-modal-form');
export function useKinderConnectCaptureSettingsModal() {
    const { showModal, hideModal } = useModal({
        lazyChildren: loadKinderConnectCaptureSettingsModalForm,
        size: 'regular',
        skeleton: (_jsxs(Box, { children: [_jsxs(Stack, { gap: 2, children: [_jsx(Skeleton, { width: 55, height: 55, variant: "circular" }), _jsx(Skeleton, { width: "100%", height: 42 })] }), _jsx(Skeleton, { width: "100%", height: 42 }), _jsx(Skeleton, { width: "100%", height: 84 }), _jsxs(Stack, { gap: 2, children: [_jsx(Skeleton, { width: "100%", height: 42 }), _jsx(Skeleton, { width: "100%", height: 42 })] })] })),
    });
    return {
        show: React.useCallback((initialValues) => showModal({ initialValues }), [showModal, hideModal]),
        hide: hideModal,
    };
}
